import type { EnumLiteral } from '../../uiModels/enumLiterals/types'
import { EnumAddLiteralPlaceholderRowCell } from './EnumAddLiteralPlaceholderRowCell'
import { EnumLiteralRowCell } from './EnumLiteralRowCell'
import { type AddLiteralPlaceholder, isAddLiteralPlaceholder } from './types'

type Props = {
  data: EnumLiteral | typeof AddLiteralPlaceholder
  column: number
  row?: number
}

export const EnumChildRowCell = ({ data, ...other }: Props) =>
  isAddLiteralPlaceholder(data) ? (
    <EnumAddLiteralPlaceholderRowCell data={data} {...other} />
  ) : (
    <EnumLiteralRowCell data={data} {...other} />
  )
